import insignia1 from "../assets/credenciales/insignia-1.png";
import insignia2 from "../assets/credenciales/insignia-2.png";
import insignia3 from "../assets/credenciales/insignia-3.png";
import insignia5 from "../assets/credenciales/insignia-5.png";
import insignia6 from "../assets/credenciales/insignia-6.png";

export const CURSOS = [
  {
    titulo: "GOOGLE CLOUD DIGITAL LEADER",
    institucion: "GOOGLE CLOUD",
    fecha: "En curso",
    descripcion:
      "Estoy cursando Google Cloud Digital Leader para fortalecer mi perfil en nube, transformación digital, datos, infraestructura, seguridad y operaciones. Durante el trayecto fui completando insignias que documentan el avance de la formación.",
    icono: "bi bi-cloud-arrow-up",
    certificado: [
      {
        nombre: "Insignia 1 - Transformación Digital con Google Cloud",
        url: insignia1,
      },
      {
        nombre: "Insignia 2 - Explora la transformación de datos con Google Cloud",
        url: insignia2,
      },
      {
        nombre: "Insignia 3 - Moderniza la infraestructura y aplicaciones con Google Cloud",
        url: insignia3,
      },
      {
        nombre: "Insignia 5 - Confianza y Seguridad con Google Cloud",
        url: insignia5,
      },
      {
        nombre: "Insignia 6 - Escala con Google Cloud Operations",
        url: insignia6,
      },
    ],
  },
  {
  titulo: "AUTOMATIZACIÓN CON N8N E IA",
  institucion: "UDEMY",
  fecha: "Noviembre 2025",
  descripcion:
    "Aprendí fundamentos de automatización de procesos utilizando n8n, integraciones entre servicios y herramientas de inteligencia artificial. Incorporé conceptos de flujos automatizados, agentes de IA y optimización de tareas repetitivas.",
  icono: "bi bi-stack",
},
  {
  titulo: "XACADEMY DEV",
  institucion: "SANTEX",
  fecha: "Mayo a Septiembre 2025",
  descripcion:
    "Formación intensiva orientada al desarrollo profesional y trabajo en equipos tecnológicos. Fortalecí habilidades técnicas y colaborativas trabajando con metodologías ágiles, resolución de problemas, comunicación y adaptación a entornos reales de desarrollo.",
  icono: "bi bi-stack",
},
  {
    titulo: "ACCESIBILIDAD Y UX",
    institucion: "CILSA",
    fecha: "Abril a Julio 2025",
    descripcion:
      "Aprendí a crear sitios, apps o productos que puedan usar personas con discapacidades (visuales, motoras, cognitivas, etc.), pensando en la inclusión desde el inicio. Comprendí cuáles son las bases de una buena experiencia de usuario: usabilidad, navegación clara, diseño intuitivo, interacción fluida, etc.",
    icono: "bi bi-stack",
  },

  {
    titulo: "ENGLISH PRE-INTERMEDIATE 1 COURSE",
    institucion: "CIUDAD BILINGÜE - ENGLISH DISCOVERIES",
    fecha: "MAYO 2025",
    descripcion:
      "Completé Nivel 2 del trayecto de aprendizaje de Inglés para el trabajo logrando llegar a nivel A2. Actualmente continúo con el nivel Pre-intermediate 2",
    icono: "bi bi-stack",
    certificado: "/certificados/certificado-ingles-2.pdf",
  },

  {
    titulo: "BOOTCAMP FULLSTACK",
    institucion: "CILSA",
    fecha: "Agosto a Diciembre 2024",
    descripcion:
      "Adquirí habilidades en desarrollo web integral, dominando tecnologías como React.js para frontend y Node.js con Express.js para backend. Implementé bases de datos SQL/NoSQL, maquetación responsive con Bootstrap, y control de versiones mediante Git.",
    icono: "bi bi-stack",
    certificado: "/certificados/fullstack-cilsa.png",
  },

  {
    titulo: "JAVASCRIPT INTENSIVO",
    institucion: "CILSA",
    fecha: "Octubre a Noviembre 2024",
    descripcion:
      "El objetivo de este curso fue reforzar los conceptos básicos sobre programación con JavaScript desde variables y tipos de datos hasta funciones e introducción al DOM.",
    icono: "bi bi-stack",
    certificado: "/certificados/intensivo-javascript.pdf",
  },

  {
    titulo: "PROGRAMACIÓN INICIAL CON PYTHON",
    institucion: "CODO A CODO 4.0",
    fecha: "Febrero a Julio de 2024",
    descripcion:
      "Adquirí fundamentos esenciales de programación mediante Python, lógica algorítmica y desarrollo de interfaces gráficas básicas con Tkinter.",
    icono: "bi bi-stack",
    certificado: "/certificados/Diploma_CAC-python.pdf",
  },

  {
    titulo: "AGILE, SCRUM Y HABILIDADES BLANDAS",
    institucion: "CODO A CODO 4.0",
    fecha: "2023-2024",
    descripcion:
      "Aprendí fundamentos de Scrum, Kanban, Lean y metodologías ágiles orientadas a mejora continua y trabajo colaborativo.",
    icono: "bi bi-stack",
    certificado: "/certificados/Diploma_CAC-agile.pdf",
  },

  {
    titulo: "FULL STACK JR",
    institucion: "ARGENTINA PROGRAMA 4.0",
    fecha: "Febrero a Noviembre 2023",
    descripcion:
      "Trayecto enfocado en Front End, Backend, Base de Datos y Desarrollo de Software.",
    icono: "bi bi-stack",

    certificado: [
      {
        nombre: "Frontend",
        url: "/certificados/frontend-argprog.pdf",
      },
      {
        nombre: "Base de Datos",
        url: "/certificados/bbdd-argprog.pdf",
      },
      {
        nombre: "Desarrollo de Software",
        url: "/certificados/desSoftware-argprog.pdf",
      },
    ],
  },

  {
    titulo: "FULL STACK - NODE/JS",
    institucion: "CODO A CODO 4.0",
    fecha: "Marzo a Julio 2023",
    descripcion:
      "Aprendí a crear servidores con Node.js y Express.js, APIs REST y bases de datos en la nube.",
    icono: "bi bi-stack",
    certificado: "/certificados/nodejs.jpeg",
  },

  {
    titulo: "REACT.JS Y DESARROLLO DE INTERFACES",
    institucion: "CODO A CODO 4.0",
    fecha: "Agosto a Octubre 2023",
    descripcion:
      "Aprendí componentes reutilizables, manejo de estado, React Router e integración con APIs REST.",
    icono: "bi bi-stack",
    certificado: "/certificados/Diploma_CAC-reactjs.pdf",
  },

  {
    titulo: "DESARROLLO WEB",
    institucion: "CODERHOUSE",
    fecha: "Junio a Agosto 2022",
    descripcion:
      "Aprendí HTML, CSS, JavaScript, Flexbox, Grid, Bootstrap, SASS y Git aplicados a proyectos web responsive.",
    icono: "bi bi-stack",
    certificado: "/certificados/coder.jpeg",
  },
];
